/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));

    if (!customElements.get("description-and-content")) {
      class DescriptionAndContent extends HTMLElement {
        constructor() {
          super();
          this.tabs = this.querySelectorAll(".tabs ul li.tab-heading");
          this.contents = this.querySelectorAll(".tab-contents ul li");
          Array.from(this.tabs).forEach((li) =>
            li.addEventListener("click", this.handleTabClick.bind(this))
          );
        }

        handleTabClick(evt) {
          let target = evt.currentTarget;
          Array.from(this.tabs).forEach((li) => {
            li.classList.remove("active");
          });
          target.classList.add("active");
          Array.from(this.contents).forEach((li) => {
            li.classList.remove("active");
          });
          this.querySelector(
            `.tab-contents ul li[data-content="${target.dataset.tab}"]`
          ).classList.add("active");
        }
      }

      customElements.define("description-and-content", DescriptionAndContent);
    }
  });
})();
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".mega_parent li").forEach((item) => {
    item.addEventListener("click", function () {
      let title = this.getAttribute("data-title");

      // Remove 'active' class from all elements
      document.querySelectorAll(".mega-section").forEach((section) => {
        section.classList.remove("active");
      });
      document.querySelectorAll(".mega_parent li").forEach((li) => {
        li.classList.remove("active");
      });

      // Add 'active' class to the clicked item and corresponding section
      this.classList.add("active");
      let targetSection = document.querySelector(
        `.mega-section[data-title="${title}"]`
      );
      if (targetSection) {
        targetSection.classList.add("active");
      }
    });
  });
  var carousel = document.querySelector(".main-carousel1");
  if (carousel) {
    new Flickity(carousel, {
      imagesLoaded: true,
      contain: true,
      percentPosition: true,
      initialIndex: 2,
      wrapAround: true,
    });
  }
});

/*
|===================================
|  Do not edit this js
|===================================
|
*/

theme.preOrderAndNotify = {
  fetchProducts: async function (products) {
    document.dispatchEvent(new CustomEvent("klaviyo-trigger"));

    let queryForGetProductConfigs = `
    query GetProducts($products: [Object]) {
      getProducts(products: $products) {
        data {
          label
          customMessage
          products{
            productId
            handle
            variants {
              title
              variantId
              sku
              available
              config
            }
          }
        }
        meta {
          message
          messageCode
          statusCode
          status
          type
          errors {
            errorField
            error
          }
          errorType
        }
      }
    }`;

    const req = await fetch(`https://ship.heirloomroses.com/gql`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        query: queryForGetProductConfigs,
        variables: { products: products },
      }),
    });
    return await req.json();
  },

  isValidateForPreOrder: function (config) {
    if (!config.start_date || !config.end_date) return false;

    const date = new Date();
    let dateFrom = config.start_date.split("T")[0].replace(/-/g, "/");
    // let dateTo = config.end_date.split('T')[0].replace(/-/g,'/');
    let currnetDate = `${date.getDate()}/${
      date.getMonth() + 1
    }/${date.getFullYear()}`;

    let dateFromParse = dateFrom.split("/");
    // let dateToParse = dateTo.split("/");
    let currentDateParse = currnetDate.split("/");

    let from = new Date(
      dateFromParse[0],
      parseInt(dateFromParse[1]) - 1,
      dateFromParse[2]
    ); // -1 because months are from 0 to 11
    //let to   = new Date(dateToParse[0], parseInt(dateToParse[1])-1, dateToParse[2]);
    let check = new Date(
      currentDateParse[2],
      parseInt(currentDateParse[1]) - 1,
      currentDateParse[0]
    );

    return check < from && config.action_name == "Preorder";
    //return check >= from && check <= to && config.action_name == 'Preorder';
  },

  isValidateForProductOverride: function (config) {
    if (!config.start_date || !config.end_date) return false;

    const date = new Date();
    // let dateFrom = config.start_date.split('T')[0].replace(/-/g,'/');
    let dateTo = config.end_date.split("T")[0].replace(/-/g, "/");
    let currnetDate = `${date.getDate()}/${
      date.getMonth() + 1
    }/${date.getFullYear()}`;

    // let dateFromParse = dateFrom.split("/");
    let dateToParse = dateTo.split("/");
    let currentDateParse = currnetDate.split("/");

    // let from = new Date(dateFromParse[0], parseInt(dateFromParse[1])-1, dateFromParse[2]);  // -1 because months are from 0 to 11
    let to = new Date(
      dateToParse[0],
      parseInt(dateToParse[1]) - 1,
      dateToParse[2]
    );
    let check = new Date(
      currentDateParse[2],
      parseInt(currentDateParse[1]) - 1,
      currentDateParse[0]
    );

    return check < to && config.action_name == "Product Override";
  },

  initPreOrderOverride: async function (target) {
    const products = Array.from(
      target.querySelectorAll(
        "quick-add button.quick-add-btn, .add-to-cart.quick-add-btn"
      )
    ).map((productNode) => {
      productNode.classList.add("btn--loading");
      let productDetailNode = productNode
        .closest(".grid-item__meta")
        .querySelector("[data-preorder-data]");
      let APIDetail = JSON.parse(productDetailNode.innerText)[0];
      // return {
      //   productId: productNode.dataset.productId,
      //   variants:[{
      //     variantId: productNode.dataset.variantId,
      //     config:{}
      //   }]
      // }
      return APIDetail;
    });

    const fetchProductsDetails = await theme.preOrderAndNotify.fetchProducts(
      products
    );
    const productsDetails = fetchProductsDetails.data.getProducts.data.products;

    productsDetails.map((product) => {
      let buttonTarget =
        target.querySelector(
          `quick-add button.quick-add-btn[data-product-id="${product.productId}"][data-variant-id="${product.variants[0].variantId}"]`
        ) ||
        target.querySelector(
          `button.quick-add-btn[data-product-id="${product.productId}"][data-variant-id="${product.variants[0].variantId}"]`
        );

      let productConfig = product.variants[0].config;
      if (theme.preOrderAndNotify.isValidateForPreOrder(productConfig)) {
        buttonTarget.querySelector("span").innerText = "Pre Order";
        if (buttonTarget.hasAttribute("data-single-variant-quick-add")) {
          buttonTarget.insertAdjacentHTML(
            "beforebegin",
            "<input type='hidden' name='properties[Message]' value='This is a pre-order item' id='pre-order-message'>"
          );
        }
      }
      buttonTarget?.classList.remove("btn--loading");
    });
  },
};

theme.notify = {
  init: function (details) {
    // listen the all buttons events
    this.container = details.container;
    this.variant = details.currentVariant;
    this.variant.available ? this.hideButton() : this.showButton();
  },
  hideButton: function () {
    // add hide class to notify button
    let notifyContainer = this.container.querySelector("notify-container");
    notifyContainer.classList.add("hide");
  },
  showButton: function () {
    // remove hide class from the button
    let notifyContainer = this.container.querySelector("notify-container");
    let notifyButton = notifyContainer.querySelector("notify-button button");
    notifyButton.setAttribute("data-var-id", this.variant.id);
    notifyButton.setAttribute("data-title", this.variant.name);
    notifyContainer.classList.remove("hide");
  },

  showModal: function (id, title) {
    // show the modal on button click
    let modal = document.querySelector("notify-modal #notify-bis-modal");
    modal.querySelector(".h4.product-title").innerText = title;
    modal.querySelector("input[name='notify-id']").value = id;
    modal.classList.remove("hide");
    modal.classList.add("modal-active");
  },

  notifyButtonsInit: function () {
    let allNotifyButtons = document.querySelectorAll("notify-button");
    Array.from(allNotifyButtons).forEach((button) => {
      button.addEventListener("click", (evt) => {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        let button = evt.currentTarget.querySelector("button");
        let variantId = button.getAttribute("data-var-id");
        let title = `${button.getAttribute(
          "data-product-title"
        )} - ${button.getAttribute("data-variant-title")}`;
        theme.notify.showModal(variantId, title);
      });
    });
  },
};

document.addEventListener("DOMContentLoaded", () => {
  theme.notify.notifyButtonsInit();
});

if (!customElements.get("notify-modal")) {
  class NotifyModal extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.errorMessage = this.form.querySelector("#error_message");
      this.closeButton = this.querySelector("button.notify-bis-close");
      this.emailSelector = this.querySelector("ul li[data-value='email']");
      this.phoneSelector = this.querySelector("ul li[data-value='sms']");

      this.closeButton.addEventListener("click", this.hideModal.bind(this));
      this.emailSelector.addEventListener(
        "click",
        this.emailVisible.bind(this)
      );
      this.phoneSelector.addEventListener(
        "click",
        this.phoneVisible.bind(this)
      );

      this.submitButton = this.querySelector(
        "button[name='klaviyo-bis-submit']"
      );
      this.submitButton.addEventListener(
        "click",
        this.handleKlaviyoSubmit.bind(this)
      );

      this.countryOptions = Array.from(
        this.form.querySelectorAll(".select-menu ul li")
      );
      // this.countryOptions.forEach(option=> option.addEventListener('click', this.handleCountryVisible.bind(this)));

      /* this.form.querySelector('.select-menu').addEventListener('click',(evt)=> {
        evt.currentTarget.classList.toggle('active')
        this.countryOptions.forEach(option=> option.classList.remove('hide'))
      }) */
    }

    emailVisible() {
      this.querySelector(".form-group .phone").classList.add("hide");
      this.querySelector(".form-group .email").classList.remove("hide");

      this.emailSelector.classList.add("active");
      this.phoneSelector.classList.remove("active");
      this.handleEmptyState();
    }

    phoneVisible() {
      this.querySelector(".form-group .email").classList.add("hide");
      this.querySelector(".form-group .phone").classList.remove("hide");

      this.phoneSelector.classList.add("active");
      this.emailSelector.classList.remove("active");
      this.handleEmptyState();
    }

    hideModal() {
      this.clearState();
      this.querySelector("#notify-bis-modal").classList.remove("modal-active");
      this.querySelector("#notify-bis-modal").classList.add("hide");
    }

    handleEmptyState() {
      this.errorMessage.innerText = "";
      this.submitButton.classList.remove("hide");
      this.form.querySelector(".success").classList.add("hide");
    }

    clearState() {
      this.querySelector("input[type='email']").value = "";
      this.querySelector("input[name='contact']").value = "";
      this.querySelector(".channel_select ul li").click();
      this.querySelector(".form-errors").innerHTML = "";
    }

    async handleKlaviyoSubmit(evt) {
      evt.preventDefault();

      let formData = {
        varId: this.form.querySelector("input#product").value,
      };
      if (
        this.form.querySelector(".channel_select ul li.active").dataset.value ==
        "email"
      ) {
        if (
          this.form.querySelector(".form-group input#email").value.length < 5
        ) {
          this.errorMessage.innerText = "Email can't be blank";
          return;
        } else {
          this.errorMessage.innerText = "";
        }

        formData.attributes = {
          email: this.form.querySelector(".form-group input#email").value,
        };
        formData.channel = "EMAIL";
      } else {
        let code = `+${this.form.querySelector("#contact_phoneCode").value}`;
        let number = this.form.querySelector(".phone_box input#contact").value;

        if (number.length < 10) {
          this.errorMessage.innerText = "Contact can't be blank";
          return;
        } else {
          this.errorMessage.innerText = "";
        }
        formData.attributes = {
          phone_number: `${code}${number}`,
        };
        formData.channel = "SMS";
      }

      // Generate the payload for sending request to klaviyo

      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: formData.attributes,
              },
            },
            channels: [formData.channel],
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${formData.varId}`,
              },
            },
          },
        },
      };

      fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=T5NGfn`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2023-12-15",
          },
          body: JSON.stringify(payload),
        }
      )
        .then((response, reject) => {
          if (response.ok) return;
          else {
            return response.json();
          }
        })
        .then((result) => {
          if (result?.errors) {
            let errorsHTML = ``;
            result.errors.forEach(
              (error) =>
                (errorsHTML += `<li class="errors">${error.detail}</li>`)
            );
            let finalErrorsHTML = `
            <ul>
              ${errorsHTML}
            </ul>
          `;

            this.form.querySelector(".form-errors").innerHTML = finalErrorsHTML;
          } else {
            this.form.querySelector(".form-errors").innerHTML = "";
            this.submitButton.classList.add("hide");
            this.submitButton.nextElementSibling.classList.remove("hide");
          }
        });
    }
  }

  customElements.define("notify-modal", NotifyModal);
}

import { formatMoney } from "@archetype-themes/utils/currency";
import { EVENTS } from "@archetype-themes/utils/events";
if (!customElements.get("add-on-products")) {
  class AddOnProducts extends HTMLElement {
    constructor() {
      super();
      this.addOnCartButton = this.querySelector(".add-ons-cart-btn");
      // Get the variant ID directly from the button, not from the custom element
      this.variantID = this.addOnCartButton?.getAttribute("data-variant-id");

      // Debug output to check if variant ID is being found
      console.log("Variant ID found:", this.variantID);

      this.addOnCartButton?.addEventListener(
        "click",
        this.addOnCartButtonClick.bind(this)
      );
    }

    async addOnCartButtonClick(evt) {
      evt.preventDefault();
      console.log("Add to cart clicked");
      console.log("Using variant ID:", this.variantID);

      if (!this.variantID) {
        console.error("No variant ID found");
        return;
      }

      await addToCart(
        [{ id: String(this.variantID), quantity: 1 }],
        this.addOnCartButton
      );
    }
  }
  customElements.define("add-on-products", AddOnProducts);
}

async function addToCart(items, button) {
  try {
    if (button) {
      button.classList.add("btn--loading");
    }

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items, sections: ["cart-ajax"] }),
    });

    if (!response.ok) {
      console.error("Failed to add to cart");
      return;
    }

    const responseData = await response.json();
    updateCartCount(responseData.sections["cart-ajax"]);
    if (items.length > 1) {
      window.location = "/cart";
      return responseData;
    }
    // document.dispatchEvent(new CustomEvent("cart:build"));
    document.dispatchEvent(
      new CustomEvent(EVENTS.ajaxProductAdded, {
        bubbles: true,
        detail: { product: responseData },
      })
    );

    return responseData;
  } catch (error) {
    console.error("Error adding to cart:", error);
  } finally {
    if (button) {
      button.classList.remove("btn--loading");
    }
  }
}

function updateCartCount(cartHTML) {
  const html = new DOMParser().parseFromString(cartHTML, "text/html");
  const newCartCount = html.querySelector(".cart-link__bubble");
  const cartCount = document.querySelector(".cart-link__bubble");

  if (newCartCount && cartCount) {
    cartCount.outerHTML = newCartCount.outerHTML;
  }
}

class ProductCard {
  constructor() {
    this.settings = {
      sizes: "30vw",
      quick_add_enable: true,
      quick_shop_enable: true,
      product_grid_image_size: "square",
      product_grid_image_fill: true,
      product_hover_image: true,
      enable_swatches: false,
      vendor_enable: false,
      product_save_amount: true,
      product_save_type: "percent",
      enable_product_tags: false,
      prefix_enable: false,
      no_actions: false,
      enable_add_to_cart: true,
      image_style: "square",
      product_tile_layout: false,
      product_grid_style: "simple",
      set_image_breathing_room: true,
    };
  }

  render(product) {

    let on_sale =
      parseFloat(product.compareAtPriceRange.minVariantPrice.amount) >
      parseFloat(product.priceRange.minVariantPrice.amount);
    let productId = product.id.split("/").pop();
    let firstVariantId = product.variants.nodes[0].id.split("/").pop();
    let product_label = "";
    if (!product.availableForSale) {
      product_label = `<div class="grid-product__tag grid-product__tag--sold-out">Subscribe</div>`;
    }
    if (on_sale && product.availableForSale &&  !product.discountAvailable) {
      product_label = `<div class="grid-product__tag grid-product__tag--sold-out">Sale</div>`;
    }

    let images = "";

    for (let index = 0; index < product.images.nodes.length; index++) {
      const image = product.images.nodes[index];
      if (index == 0) {
        images += `
          <div class="grid__image-ratio grid__image-ratio--square">
            <is-land on:visible="" data-image-type="" ready="">
              <img
                src="${image.url}"
                alt="${image.altText}"
                srcset=""
                width="${image.width}" 
                height="${image.height}" 
                loading="lazy" 
                class=" image-style--square image-element" 
                sizes="${this.settings.sizes}" 
                data-animate="fadein"
              />
            </is-land>
          </div>`;
      }
      if (
        this.settings.product_hover_image &&
        product.images.nodes.length > 1 &&
        index == 1
      ) {
        images += `
          <div class="grid-product__secondary-image small--hide">
            <is-land on:visible="" data-image-type="" ready="">
              <img
                src="${image.url}"
                alt="${image.altText}"
                srcset=""
                width="${image.width}" 
                height="${image.height}" 
                loading="lazy" 
                class=" image-style--square image-element" 
                sizes="${this.settings.sizes}" 
                data-animate="fadein"
              />
            </is-land>
          </div>`;
      }
    }

    let vendor = this.settings.vendor_enable
      ? `<div class="grid-product__vendor">${product.vendor}</div>`
      : "";

    let priceHTML = `
    <span class="js-pricess grid-product__price--current">
      <span aria-hidden="true">${this.getPrice(
        product.priceRange.minVariantPrice.amount
      )}</span>
      <span class="visually-hidden">${this.getPrice(
        product.priceRange.minVariantPrice.amount
      )}</span>
    </span>`;

    if (on_sale && product.availableForSale) {
      priceHTML += `<span class="grid-product__price--original">${this.getPrice(
        product.compareAtPriceRange.minVariantPrice.amount
      )}</span>`;
    }
    let wishlistButton = `
       <button
        type="button"
        aria-label="Add to Wishlist"
        class="wkh-button wkh-align-center wkh-align-content-center"
        data-product-handle="${product.handle}"
      >
        <div class="wkh-icon" icon="wishlist">
          <svg viewBox="0 0 64 64">
            <path d="M32.012,59.616c-1.119-.521-2.365-1.141-3.707-1.859a79.264,79.264,0,0,1-11.694-7.614C6.316,42,.266,32.6.254,22.076,0.244,12.358,7.871,4.506,17.232,4.5a16.661,16.661,0,0,1,11.891,4.99l2.837,2.889,2.827-2.9a16.639,16.639,0,0,1,11.874-5.02h0c9.368-.01,17.008,7.815,17.021,17.539,0.015,10.533-6.022,19.96-16.312,28.128a79.314,79.314,0,0,1-11.661,7.63C34.369,58.472,33.127,59.094,32.012,59.616Z"/>
          </svg>
        </div>
      </button>
    `;

    let actBTN = ``;

    if (this.settings.quick_add_enable) {
      if (product.availableForSale) {
        let button = "";
        if (product.variants.nodes.length > 1) {
          button = `
          <tool-tip-trigger
            class="tool-tip-trigger"
            data-tool-tip="QuickAdd"
            data-tool-tip-classes="quick-add-modal"
            defer-hydration
          >
            <span class="tool-tip-trigger__content" data-tool-tip-trigger-content=""></span>
            <button
              onclick="event.preventDefault()"
              data-product-id="${productId}"
              data-variant-id="${firstVariantId}"
              type="button" class="quick-add-btn js-quick-add-form js-modal-open-quick-add btn" title="Add to cart"
            >
              <span class="btn-text">
                Add to cart
              </span>
            </button>
          </tool-tip-trigger>
          <script type="module">import 'components/tool-tip-trigger'</script>`;
        } else {
          button = `
            <button
              onclick="event.preventDefault();"
              type="button" 
              class="quick-add-btn js-quick-add-form js-modal-open-quick-add btn"
              title="Add to cart"
              data-id="${firstVariantId}"
              data-product-id="${productId}"
              data-variant-id="${firstVariantId}" 
              data-single-variant-quick-add
            >
              <span class="btn-text">
                Add to cart
              </span>
            </button>`;
        }
        actBTN += `
          <is-land on:idle="" ready="">
            <quick-add>
              ${button}
            </quick-add>
            <script type="module">
              import 'components/quick-add'
            </script>
          </is-land>`;

        actBTN += `
          <script type="text/javascript" data-preorder-data>[{"productId" : "${productId}","handle": "${product.handle}" ,"variants" : [{"available": true,"variantId" : "${firstVariantId}","sku" : "${product.variants.nodes[0].sku}","config":{}}]}]</script>`;
      } else {
        actBTN += `
          <notify-container>
            <notify-button>
              <button
                type="button"
                class="btn btn--full btn--primary notify"
                data-var-id="${firstVariantId}"
                data-product-title="${product.title}"
                data-variant-title="${product.variants.nodes[0].title}"
              >
                <span data-notify-btn-text>
                  Notify Me
                </span>
              </button>
            </notify-button>
          </notify-container>`;
      }
    }

    let html = `
      <div class="grid-item grid-product grid-product-image-breathing-room--true">
        <div class="product-grid-item" data-product-handle="${product.handle}" data-product-id="${productId}" data-product-grid-item>
          <div class="grid-item__content">
            <a href="${product.onlineStoreUrl}" class="grid-item__link">
              <div class="grid-product__image-wrap">
                <div class="grid-product__actions">
                  <is-land on:idle="" ready="">
                    <quick-shop>
                      <tool-tip-trigger class="tool-tip-trigger" data-tool-tip="QuickShop" data-tool-tip-classes="quick-shop-modal">
                        <span class="tool-tip-trigger__content" data-tool-tip-trigger-content=""></span>
                        <button type="button"
                          class="btn quick-product__btn js-modal-open-quick-modal-${productId} small--hide" title="${product.title}"
                          data-handle="${product.handle}" onclick="event.preventDefault()"
                        >
                          Quick shop
                        </button>
                      </tool-tip-trigger>
                      <script type="module">
                        import 'components/tool-tip-trigger'
                      </script>
                    </quick-shop>
                    <script type="module">
                      import 'components/quick-shop'
                    </script>
                  </is-land>
                </div>
                <div class="grid-product__tags">
                  ${product_label}
                </div>
                ${images}
              </div>
              <div class="grid-item__meta">
                <div class="grid-item__meta-main">
                  <div class="grid-product__title">${product.title}</div>
                  ${vendor}
                </div>
                <div class="grid-item__meta-secondary">
                  <div class="grid-product__price">
                    ${priceHTML}
                  </div>
                   <div class="wishlist-floating-btn">
                      ${wishlistButton}
                   </div>
                </div>
                ${actBTN}
              </div>
            </a>
          </div>
        </div>
      </div>
    `;

    return html;
  }

  getPrice(price) {
    let formattedPrice = formatMoney(
      parseFloat(price) * 100,
      theme.settings.money_format
    );
    return formattedPrice.endsWith(".00")
      ? formattedPrice.slice(0, -3)
      : formattedPrice;
  }
}

const productCard = new ProductCard();

theme.ajaxProductFetch = {
  render: function (product) {
    return productCard.render(product);
  },
};

document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const form = document.querySelector(".klaviyo-form-VTD8Nv");
    if (form) {
      const button = form.querySelector("button");
      if (button) {
        button.setAttribute("aria-label", "Subscribe to newsletter");
        clearInterval(interval); // Stop checking once it's found and updated
      }
    }
  }, 300); // checks every 300ms in case it's loaded asynchronously
});


document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".buy-buttons--wrapper")) return;

  const observer = new MutationObserver(() => {
    const chatIframe = document.querySelector("iframe#SIENA_CHAT_IFRAME");
    if (chatIframe) {
      if (window.innerWidth <= 768) {
        chatIframe.style.position = "fixed"; 
        chatIframe.style.bottom = "60px"; 
      }
      observer.disconnect(); 
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  
});

